import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-396b19e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-slot" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-chat-line-square" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-chat-dot-square" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_List = _resolveComponent("List")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MapLocation = _resolveComponent("MapLocation")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    "element-loading-text": "Loading...",
    "element-loading-spinner": "el-icon-loading",
    data: _ctx.orderlist,
    "max-height": _ctx.paneHeight,
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "order_id",
        label: "発注番号",
        "class-name": "right",
        width: "80"
      }),
      _createVNode(_component_el_table_column, {
        prop: "dweek",
        label: "配布期間",
        width: "180"
      }),
      _createVNode(_component_el_table_column, {
        prop: "segment",
        label: "配布方法",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.distributeWay[scope.row.segment]), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "size",
        label: "サイズ",
        width: "80"
      }),
      _createVNode(_component_el_table_column, {
        label: "画像",
        width: "60"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_image, {
            style: {"width":"30px","height":"30px"},
            src: _ctx.urlStr(scope.row.order_id)
          }, {
            error: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Picture)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 2
          }, 1032, ["src"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "order_qty",
        "class-name": "right",
        label: "発注部数",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(Number(scope.row.order_qty).toLocaleString()), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "部数内訳",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_popover, {
            trigger: "hover",
            placement: "top"
          }, _createSlots({
            default: _withCtx(() => [
              (scope.row.summary_qty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(scope.row.summary_qty), (key) => {
                      return (_openBlock(), _createElementBlock("p", { key: key }, _toDisplayString(key) + ": " + _toDisplayString(scope.row.summary_qty[key].toLocaleString()), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (scope.row.summary_qty)
              ? {
                  name: "reference",
                  fn: _withCtx(() => [
                    _hoisted_3
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "order_price",
        "class-name": "right",
        label: "発注金額（円）",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(Number(scope.row.order_price).toLocaleString()), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "payment",
        label: "支払方法",
        width: "80"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_ctx.paymentStr(scope.row.payment)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "メモ",
        width: "50"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_popover, {
            trigger: "hover",
            placement: "top",
            content: scope.row.comment
          }, _createSlots({ _: 2 }, [
            (scope.row.comment)
              ? {
                  name: "reference",
                  fn: _withCtx(() => [
                    _hoisted_4
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["content"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "order_date",
        label: "発注日時"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.order_date.substr(0, 16)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        prop: "order_id",
        label: "操作",
        width: "140"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_button, {
            type: "success",
            circle: "",
            onClick: ($event: any) => (_ctx.detail(scope.row.order_id)),
            title: "反響入力"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_List)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            circle: "",
            onClick: ($event: any) => (_ctx.recall(scope.row.order_id)),
            title: "地図呼出"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_MapLocation)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data", "max-height"])), [
    [_directive_loading, _ctx.loading]
  ])
}